/**
 * @typedef {object} PdfViewport
 * @property {number} width
 * @property {number} height
 */

/**
 * @typedef {object} PdfRenderTask
 * @property {Promise<void>} promise
 * @property {() => void} [cancel]
 */

/**
 * @typedef {object} PdfPage
 * @property {(params: { scale: number }) => PdfViewport} getViewport
 * @property {(params: { canvasContext: CanvasRenderingContext2D, viewport: PdfViewport }) => PdfRenderTask} render
 */

/**
 * @typedef {object} PdfDocument
 * @property {number} numPages
 * @property {(pageNumber: number) => Promise<PdfPage>} getPage
 * @property {() => Promise<void>} [destroy]
 */

/**
 * Parses PDF bytes on a worker thread. Wasm is disabled so CRA does not need extra assets.
 *
 * @param {ArrayBuffer | Uint8Array} data
 * @returns {Promise<PdfDocument>}
 */
export async function openPdfDocument(data) {
  const { getDocument } = await import("pdfjs-dist/legacy/webpack.mjs");
  const bytes = data instanceof Uint8Array ? data : new Uint8Array(data);
  return getDocument({
    data: bytes,
    disableAutoFetch: true,
    disableRange: true,
    disableStream: true,
    useWasm: false,
  }).promise;
}
